import { useEffect, useRef, useState } from "react";

/**
 * Keeps a stable placeholder in the document and only mounts expensive
 * below-the-fold content shortly before a visitor reaches it.
 */
export default function DeferredSection({
  children,
  minHeight,
}: {
  children: React.ReactNode;
  minHeight: number;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const [isNearViewport, setIsNearViewport] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node || typeof IntersectionObserver === "undefined") {
      setIsNearViewport(true);
      return;
    }

    const observer = new IntersectionObserver(
      entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        setIsNearViewport(true);
        observer.disconnect();
      },
      { rootMargin: "900px 0px" },
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={ref} style={isNearViewport ? undefined : { minHeight }}>
      {isNearViewport ? children : null}
    </div>
  );
}
